



























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  JinroGameDocument,
  JinroGamePlayinfoDocument,
} from "@/services/datatypes";
import ProceedPlayButton from "./ProceedPlayButton.vue";
import StopTimerButton from "./StopTimerButton.vue";
import RestartTimerButton from "./RestartTimerButton.vue";

@Component({
  components: {
    ProceedPlayButton,
    StopTimerButton,
    RestartTimerButton,
  },
})
export default class Gm extends Vue {
  @Prop() readonly jinroGameId!: string;
  @Prop() readonly jinroGame!: JinroGameDocument;
  alreadyShownSnackbarMessage = "";

  get gameMasterMessage(): string {
    if (this.jinroGame) {
      return this.jinroGame.gmMessage;
    }
    return "";
  }
  get isOwner(): boolean {
    if (this.jinroGame) {
      return (
        this.$store.state.firebaseUser &&
        this.jinroGame.owner === this.$store.state.firebaseUser.uid
      );
    }
    return false;
  }
  get timerExisted(): boolean {
    return !!this.endedAt;
  }

  get gmTimerStoppedAt(): firebase.firestore.Timestamp | null {
    if (!this.$store.state.jinroGamePlayinfo) {
      return null;
    }
    const jinroGamePlayinfo = this.$store.state
      .jinroGamePlayinfo as JinroGamePlayinfoDocument;

    return jinroGamePlayinfo.gmTimerStoppedAt as firebase.firestore.Timestamp;
  }

  get isTimerStopped(): boolean {
    if (!this.gmTimerStoppedAt) {
      return false;
    }

    return !!this.gmTimerStoppedAt;
  }

  get isNextPlayQueueProcessing(): boolean {
    if (this.jinroGame && this.jinroGame.isNextPlayQueueProcessing) {
      return this.jinroGame.isNextPlayQueueProcessing;
    }
    return false;
  }

  get hasBeenGameEnded(): boolean {
    if (this.jinroGame && this.jinroGame.hasBeenGameEnded) {
      return this.jinroGame.hasBeenGameEnded;
    }
    return false;
  }

  get endedAt(): firebase.firestore.Timestamp | null {
    if (
      !this.$store.state.jinroGamePlayinfo ||
      !this.$store.state.jinroGamePlayinfo.endedAt
    ) {
      return null;
    }
    const endedAt = this.$store.state.jinroGamePlayinfo.endedAt;

    return endedAt;
  }
}
